import Slider from "./Slider";
import Introduction from "./Introduction";
import Instgram from "./Instgram";
import Skill from "./Skill";
import { device } from '../MainContents/Style/StyleDevice';
import ScrollToTopOnMount from '../MainContents/AutoScrollTop';
import ToggleContent from './ToggleContent';
import styled from 'styled-components';

const Mt =styled.div`
margin-top:130px;
@media ${device.mobile}{
  margin-top:80px;
  }
`;

const GoogleMapIframe = styled.iframe`
  width: 90%;
  margin: auto;
  height: 100vh;
`;
const Main: React.VFC = () => {
  return (
    <div className="App">
      <ScrollToTopOnMount />
      <Mt></Mt>
      {/* スライダー */}
      <Slider />
      {/* <div className="p-4">
      <ToggleContent
        button1Text="イベント・行事カレンダー(秦校)"
        button2Text="イベント・行事カレンダー(旭校)"
        content1={"https://calendar.google.com/calendar/embed?src=a169baafed4b70d41d0079ba2cf56b89d37fe10d120d3f21d797f4d2307279a9%40group.calendar.google.com&ctz=Asia%2FTokyo"}
        content2={"https://calendar.google.com/calendar/embed?src=8d1f3d22c60a575ea603641e40b2757a3396d9a1cb06662a3ec3e987e94f79da%40group.calendar.google.com&ctz=Asia%2FTokyo"}
      />
    </div> */}
      {/* 体験会のご案内 */}
      <Introduction />
      {/* <Instgram /> */}
      <Skill />
    </div>
  );
}
export default Main;
